import config from '../config'

class HeapService {
  initialize() {
    let heap = window.heap || []
    window.heap = heap

    heap.load = function (e, t) {
      window.heap.appid = e
      window.heap.config = t = t || {}
      let r = t.forceSSL || document.location.protocol === 'https:'
      let a = document.createElement('script')
      a.type = 'text/javascript'
      a.async = !0
      a.src = (r ? 'https:' : 'http:') + '//cdn.heapanalytics.com/js/heap-' + e + '.js'
      let n = document.getElementsByTagName('script')[0]
      n.parentNode.insertBefore(a, n)

      for (
        let o = function (e) {
            return function () {
              heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
            }
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty'
          ],
          c = 0;
        c < p.length;
        c++
      ) {heap[p[c]] = o(p[c])}
    }

    heap.load(config.HEAP_API_KEY)
  }

  generateUniqueEventID({
    component,
    view,
  }) {
    return `event-${view}-${component}`
  }
}

const heapService = new HeapService()

export default heapService



// WEBPACK FOOTER //
// ./src/app/infrastructure/HeapService.js